<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
                <!--
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :href="source"
                      icon
                      large
                      target="_blank"
                      v-on="on"
                    >
                      <v-icon>mdi-code-tags</v-icon>
                    </v-btn>
                  </template>
                  <span>Source</span>
                </v-tooltip>
                -->
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="username"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-on:click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import router from '../router'

import { store } from '../store';
import { loginUrl } from '../config.js';

const axios = require('axios');

  export default {
    props: {
      source: String,
    },
    data: () => ({
      username : '',
      password : ''
    }),
    mounted () {
      this.reset();
    },
    methods: {
        login: function(){

            var page = this;

            axios.post(loginUrl,{}, {
                auth: {
                    username: this.username,
                    password: this.password
                }
            })
            .then(function (response) {
                // handle success
                console.log(response);

                store.commit('setAuth',response.data);
                router.push({name:'Home'});
                
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                page.$fire({
                  title: "Login Error!",
                  text: "User or password are not correct, please retry.",
                  type: "error",
                  timer: 5000
                }).then(r => {
                  console.log(r.value);
                });
            });
        },
        reset(){
          store.commit('resetAuth');
        }
    }
  }
</script>